export const GENDERS = ['Male', 'Female', 'N/A'];
